<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>《战魂旅人》以著名动漫为蓝本，我们倾力打造了一款能够深度还原经典剧情的游戏。通过游戏场景和剧情线，为玩家带来了前所未有的沉浸式体验。在游戏中，玩家将扮演一位船长，负责招募并带领一群强大的伙伴，共同踏上一段充满挑战与奇遇的伟大旅程。</p>
    <!-- <pre> -->
    <h2 class="title" style="margin-bottom: 0px">游戏特色</h2>
    <div class="content">
      <div class="content-item">
        <h4>【经典角色】</h4>
        将与动漫中的经典角色并肩作战。游戏还原动漫的经典造型，以及战斗中表现出与动漫一致并具有观赏性的动作效果，让人仿佛置身于航海时代之中。这些角色不仅是视觉上的享受，更能辅助玩家通过层层战役。自己喜欢的角色在养成中逐渐变得强大，满足感玩家所追求的核心目标。
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【战术策略】</h4>
        我们还原了动漫的及时战斗变化，与传统回合制玩法不同，富有更高的战术策略。玩家可使用同名战术卡，提升战术技能星级，激活新战术卡星级后，可提升全英雄属性。通过不断的冒险，会开启更多的玩法，让你在不同玩法中使用不同的布阵策略，增加游戏整体体验的体验感受。
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【角色提升】</h4>
        与常规放置卡牌不同，多类型策略养成形式，以及多种特色技能的搭配，使角色使用策略加强。养成内容包括：升级、升星、装备、符石、刻印、恶魔果实、名刀、图书馆等等系统，提升角色偏向性养成策略选择。
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【玩法系统】</h4>
        游戏特色系统中，分别为：冒险、历练、挑战、竞技、经营五大玩法系统，每个玩法中都分别有不同特色玩点。在不同玩法中，需求英雄和策略不同，玩家需针对不同玩法，培养不同角色进行闯关，以及与各个玩家之间的争夺。
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
